/**
 * ImageWithFallback Component
 * Handles image loading with fallback support
 */

import React, { useState } from 'react';

export function ImageWithFallback({ src, alt, style = {}, fallback = '/default-image.avif' }) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const containerStyle = {
    position: 'relative',
    ...style,
  };

  const loaderStyle = {
    position: 'absolute',
    inset: 0,
    background: '#f5f5f5',
    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
  };

  const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    opacity: loading ? 0 : 1,
    transition: 'opacity 0.3s ease',
    ...style,
  };

  return (
    <div style={containerStyle}>
      {loading && <div style={loaderStyle} />}
      <img
        src={error ? fallback : src}
        alt={alt}
        style={imgStyle}
        onLoad={() => setLoading(false)}
        onError={() => {
          setError(true);
          setLoading(false);
        }}
      />
    </div>
  );
}

// Add keyframes for pulse animation
const pulseStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: .5; }
  }
`;

if (typeof document !== 'undefined' && !document.head.querySelector('style[data-bp-pulse]')) {
  const styleSheet = document.createElement('style');
  styleSheet.setAttribute('data-bp-pulse', 'true');
  styleSheet.textContent = pulseStyles;
  document.head.appendChild(styleSheet);
}

export default ImageWithFallback;
